import paymentsApi from '@/api/payments'
import { saveIVKey } from '@/utils/IVKeys'

const getDefaultState = () => ({
  data: {}
})

const state = getDefaultState()

const mutations = {
  SET_DATA: (state, data) => {
    state.data = data
  }
}

const actions = {
  async createRechargeSaleOrder ({ commit, state, rootState, rootGetters }) {
    const params = {
      product_id: rootGetters['products/rechargeProduct'].id,
      amount: rootState.rechargeForm.amount,
      card: rootState.rechargeForm.cardNumber,
      card_type: rootState.rechargeForm.cardType,
      expiration: rootGetters['rechargeForm/cardExpirationDate']
    }

    try {
      const { data } = await paymentsApi.preparePayment(params)

      commit('SET_DATA', data)

      saveIVKey({
        orderId: data.id,
        ivKey: data.iv_key,
        ivKeyExp: data.iv_key_expires_at
      })
    } catch (error) {
      // TODO: Show error modal
      // console.log(error)
    }
  },
  async createSaleOrder ({ commit, state, rootState, rootGetters }) {
    const params = {
      product_id: rootState.products.selectedProductId,
      vehicle_id: rootState.saleOrderForm.selectedVehicleId,
      card: rootState.saleOrderForm.cardNumber,
      expiration: rootGetters['saleOrderForm/cardExpirationDate'],
      card_type: rootState.saleOrderForm.cardType
    }

    try {
      const { data } = await paymentsApi.preparePayment(params)

      commit('SET_DATA', data)

      saveIVKey({
        orderId: data.id,
        ivKey: data.iv_key,
        ivKeyExp: data.iv_key_expires_at
      })
    } catch (error) {
      // TODO: Show error modal
      // console.log(error)
    }
  }
}

const getters = {
  saleOrderReference3D: (state) => {
    if (state.data.id) {
      return `${state.data.id}-auth${process.env.VUE_APP_AUTH_CODE_PREFIX}`
    }

    return ''
  },
  saleOrderId: (state) => {
    return state.data.id
  },
  saleOrderTotal: (state) => {
    return state.data.total
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
